import { Phone, MessageCircle } from "lucide-react";
import { useState } from "react";

const PHONE_NUMBER = "07492639223";
const WHATSAPP_NUMBER = "447492639223"; // International format without +

export const FloatingContactButtons = () => {
  const [showTooltip, setShowTooltip] = useState({ call: false, whatsapp: false });

  const handleCall = () => {
    window.location.href = `tel:${PHONE_NUMBER}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=Hi, I'd like to get a quote for car transportation`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* WhatsApp Button */}
      <div className="relative">
        <button
          onClick={handleWhatsApp}
          onMouseEnter={() => setShowTooltip({ ...showTooltip, whatsapp: true })}
          onMouseLeave={() => setShowTooltip({ ...showTooltip, whatsapp: false })}
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group hover:scale-110"
          aria-label="Contact via WhatsApp"
        >
          <MessageCircle className="w-7 h-7" />
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full animate-ping"></span>
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full"></span>
        </button>
        
        {showTooltip.whatsapp && (
          <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-slate-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap shadow-lg">
            WhatsApp Us
            <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-slate-900"></div>
          </div>
        )}
      </div>

      {/* Call Button */}
      <div className="relative">
        <button
          onClick={handleCall}
          onMouseEnter={() => setShowTooltip({ ...showTooltip, call: true })}
          onMouseLeave={() => setShowTooltip({ ...showTooltip, call: false })}
          className="w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group hover:scale-110"
          aria-label="Call us now"
        >
          <Phone className="w-7 h-7" />
        </button>
        
        {showTooltip.call && (
          <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-slate-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap shadow-lg">
            Call: {PHONE_NUMBER}
            <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-slate-900"></div>
          </div>
        )}
      </div>

      {/* Pulse animation for emergency visibility */}
      <style>{`
        @keyframes pulse-ring {
          0% {
            transform: scale(0.95);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.7;
          }
          100% {
            transform: scale(0.95);
            opacity: 1;
          }
        }
        .group:hover {
          animation: pulse-ring 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};
